module.exports = __webpack_public_path__ + "static/media/layers.ee64a3d4.png";